/*!
  * devtools-if v9.2.0-beta.30
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const IntlifyDevToolsHooks =  {
    I18nInit: 'i18n:init',
    FunctionTranslate: 'function:translate'
};

exports.IntlifyDevToolsHooks = IntlifyDevToolsHooks;
